import $ from 'jquery';

function backgroundVideosInit() {
  // Fade in videos
  const $fadeInVideos = $('.video-bg video'),
        isPlaying = 'is-playing',
        apple = /iPad|iPhone|iPod/,
        iOS = apple.test(navigator.platform) || apple.test(navigator.userAgent),
        playsInline = /OS 10_[1-9]{1,2} like/.test(navigator.userAgent); // Test for iOS 10.1+

  // Scrap videos on iOS because it won't auto play, it adds it's own play icon and opens the
  // media player when clicked. Display the poster image instead.
  // But only until iOS <= 10.0 as since 10.1 `playsinline` works for background videos.
  if (iOS && !playsInline) {
    $fadeInVideos.map((index, item) => {
      const src = $(item).attr('poster');
      $(item).closest('.video-bg').html(`<img src="${src}" />`);
      return true;
    });
    $fadeInVideos.remove();
  }

  $fadeInVideos.each(function () {
    const $this = $(this);

    if ($this[0].currentTime) {
      // It's already started playing
      $this.addClass(isPlaying);
    } else {
      // It hasn't started yet, wait for the playing event
      $this.on('playing', () => {
        $this.addClass(isPlaying);
      });
    }
  });
}

export { backgroundVideosInit };



// WEBPACK FOOTER //
// ./backgroundVideosInit.js